export const en = {
  billing: {
    title: 'Billing & Subscription',
    description: 'Manage your subscription and billing information',
    currentPlan: 'Current Plan',
    upgradePlan: 'Upgrade Your Plan',
    choosePlan: "Choose the plan that's right for you",
    features: 'Features',
    billingInfo: 'Billing Information',
    currentPeriod: 'Current Period',
    manageSubscription: 'Manage Subscription',
    selectPlan: 'Select {plan}',
    popular: 'Popular',
    savePercent: 'Save {percent}%',
    perMonth: '/month',
    perYear: '/year',
    billedAnnually: '(billed annually)',
    memberLimit: 'Up to {count} family members',
    memberLimitUnlimited: 'Unlimited family members',
    monthly: 'Monthly',
    annual: 'Annual',
    success: {
      title: 'Subscription Activated!',
      description: 'Your payment was successful and your subscription is now active.',
      message: 'You now have access to all premium features. Thank you for your purchase!',
      planActivated: 'has been activated',
      goToApp: 'Go to App',
      manageBilling: 'Manage Billing',
      continue: 'Continue to Billing',
    },
    cancel: {
      title: 'Payment Canceled',
      description: 'Your payment was canceled and no charges were made.',
      message: 'You can try again anytime. If you need help, please contact our support team.',
      tryAgain: 'Try Again',
      goToApp: 'Go to App',
    },
    status: {
      active: 'Active',
      canceled: 'Canceled',
      canceling: 'Canceling',
      pastDue: 'Past Due',
      grandfathered: 'Grandfathered',
    },
    grandfathered: {
      title: 'Lifetime Pro Access',
      message: 'You have grandfathered lifetime access to Pro features. Thank you for being an early supporter!',
    },
    planSuffix: 'Plan',
    currentPeriodLabel: 'Current Period:',
    subscriptionWillCancel: 'Subscription will cancel on',
    paymentsComingSoon: 'Online payments will be available soon. Plans can currently be changed manually.',
    plans: {
      free: {
        name: 'Free',
        description: 'Get started with basic features',
        fullName: 'Free Plan',
        features: {
          memberLimit: 'Up to 2 family members',
          shoppingLists: 'Shared shopping lists',
          recipes: 'Shared family recipes',
          keepExport: 'Google Keep export',
          aiByok: 'AI import with your own OpenRouter key',
        },
      },
      basic: {
        name: 'Basic',
        description: 'For smaller families',
        fullName: 'Basic Plan',
        features: {
          memberLimit: 'Up to 5 family members',
          everythingInFree: 'Everything in Free',
          aiImport: 'AI recipe import (system key, limited)',
        },
      },
      pro: {
        name: 'Pro',
        description: 'Unlimited members + higher AI budget',
        fullName: 'Pro Plan',
        features: {
          memberLimit: 'Unlimited family members',
          everythingInBasic: 'Everything in Basic',
          aiImport: 'Higher AI budget (system key)',
        },
      },
    },
    upgradeBanner: {
      title: 'Need more members or AI?',
      description: 'Upgrade to Basic or Pro to invite more people and use AI import.',
      button: 'View Plans',
    },
    errors: {
      checkoutFailed: 'Failed to create checkout session. Please try again.',
      portalFailed: 'Failed to open billing portal. Please try again.',
      ownerOnly: 'Only the family owner can manage billing.',
    },
  },
}
